import { selectUserById, updateCurrentUser } from 'modules/authentication'
import { PictureUpload } from 'modules/common'
import { useAppDispatch, useAppSelector } from 'modules/core'
import { AttachmentEntity } from 'openapi'

interface ProfilePictureUploadProps {
  userId: string
}

export const ProfilePictureUpload = ({ userId }: ProfilePictureUploadProps) => {
  const dispatch = useAppDispatch()
  const user = useAppSelector(state => selectUserById(state, userId))
  const imageUrl = user?.avatar?.publicUrl

  const handleUploadComplete = async (file: AttachmentEntity) => {
    await dispatch(updateCurrentUser({ avatarId: file.id })).unwrap()
  }

  const handleClear = async () => {
    await dispatch(updateCurrentUser({ avatarId: null })).unwrap()
  }

  return (
    <PictureUpload
      currentImageUrl={imageUrl}
      onUploadComplete={handleUploadComplete}
      onClear={handleClear}
      name={user?.name}
      id={user?.id}
    />
  )
}
